function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileerror(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166.345,
    height: 120,
    viewBox: "0 0 166.345 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "1mtcj0lxra"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 664",
    transform: "translate(0 -.315)",
    style: {
      stroke: "#707070",
      fill: "#fff"
    },
    d: "M0 0h166.345v120H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17",
    transform: "translate(0 .314)",
    style: {
      clipPath: "url(#1mtcj0lxra)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "37 Invoice"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46633",
    d: "M13.092 11.049A10.407 10.407 0 0 0 4 21.55v11.487a5.509 5.509 0 0 0 5.51 5.509H24.2V21.1a10.112 10.112 0 0 0-11.108-10.051z",
    transform: "translate(28.001 10.214)",
    style: {
      fill: "#c1c1c1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46634",
    d: "M83.672 11H9.5c3.544 0 6.427 2.828 6.427 10.1v68.167a15.2 15.2 0 0 0 15.187 15.187h56.23a1.836 1.836 0 0 0 1.836-1.836V16.509A5.515 5.515 0 0 0 83.672 11z",
    transform: "translate(32.602 10.214)",
    style: {
      fill: "#eee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46635",
    d: "M89.654 53.295c-.354 6.574-2.461 14.875-12.286 17.244-.257.073-.514.129-.771.184-.386.018-53.894-.035-54.247.018 9.971-4.46 9.325-10.653 9.77-17.684a1.833 1.833 0 0 1 1.836-1.726h53.861a1.86 1.86 0 0 1 1.836 1.965z",
    transform: "translate(43.35 43.945)",
    style: {
      fill: "#c1c1c1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46637",
    d: "M62.728 29.673H27.836a1.836 1.836 0 1 1 0-3.673h34.892a1.836 1.836 0 1 1 0 3.673z",
    transform: "translate(46.402 22.759)",
    style: {
      fill: "#67676b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46638",
    d: "M62.728 36.673H27.836a1.836 1.836 0 1 1 0-3.673h34.892a1.836 1.836 0 1 1 0 3.673z",
    transform: "translate(46.402 28.614)",
    style: {
      fill: "#67676b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46639",
    d: "M62.728 43.673H27.836a1.836 1.836 0 1 1 0-3.673h34.892a1.836 1.836 0 1 1 0 3.673z",
    transform: "translate(46.402 34.469)",
    style: {
      fill: "#67676b"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10667",
    transform: "translate(59.548 45.087)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 9211",
    width: 11.018,
    height: 11.018,
    rx: 1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 9212",
    width: 11.018,
    height: 11.018,
    rx: 1,
    transform: "translate(0 12.855)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 9213",
    width: 11.018,
    height: 11.018,
    rx: 1,
    transform: "translate(0 25.71)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 9214",
    width: 11.018,
    height: 11.018,
    rx: 1,
    transform: "translate(0 38.564)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46640",
    d: "M62.728 50.673H27.836a1.836 1.836 0 1 1 0-3.673h34.892a1.836 1.836 0 1 1 0 3.673z",
    transform: "translate(46.402 40.324)",
    style: {
      fill: "#67676b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46641",
    d: "M58.528 2c-22.035.569-22.039 32.482 0 33.055 22.034-.569 22.039-32.482 0-33.055z",
    transform: "translate(60 2.686)",
    style: {
      fill: "#de350b"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "x (2)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 11",
    transform: "translate(113 15.686)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    },
    d: "M12 0 0 12"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 12",
    transform: "translate(113 15.686)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    },
    d: "m0 0 12 12"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46642",
    d: "M-.653-10.994H-2.67a4.015 4.015 0 0 0-.653-1.669l2.166.007.518-1.889h-9.389l-.554 2.195h2.67a2.374 2.374 0 0 1 2.5 1.357h-4.659l-.511 1.861h5.241a2.4 2.4 0 0 1-2.571 1.575h-2.457l.007 1.577L-5.391 0h2.962v-.128l-4.489-5.5.085-.028C-4.247-6-2.983-7.273-2.678-9.134h1.52z",
    transform: "translate(89.657 43.198)",
    style: {
      fill: "#c1c1c1"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileerror);
export default __webpack_public_path__ + "static/media/fileerror.b95cf39284ced9dd3a2b5f694688c8ab.svg";
export { ForwardRef as ReactComponent };